<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3>{{salesMonthlyLan.indexText}}</h3>
      </div>
      <div class="panel" v-loading="loading" element-loading-spinner="el-icon-loading">
        <mtable
          v-if="trData"
          :thData="thData"
          :trData="trData"
          :selPage="selPage"
          :page="page"
          :link="link"
          :back="back"
          :region="curArea"
          :multiLanguage="salesMonthlyLan"
          :jsonExcelAjax="jsonExcelAjax"
          :downLoadTran="downLoadTran"
          :name="name"
          @tableChange="tableAjax"
        >
          <div slot="handle" class="monthlyHandle">
            <div class="searchDiv">
              <span>{{salesMonthlyLan.start_time}}</span>
              <el-date-picker
                v-model="beginTime"
                :placeholder="salesMonthlyLan.selectTimeText"
                style="width: 200px"
              ></el-date-picker>
            </div>
            <div class="searchDiv">
              <span>{{salesMonthlyLan.end_time}}</span>
              <el-date-picker
                v-model="endTime"
                :placeholder="salesMonthlyLan.selectTimeText"
                style="width: 200px"
              ></el-date-picker>
            </div>
            <div class="btnDiv">
              <el-button type="primary" @click="searchData">{{salesMonthlyLan.search}}</el-button>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from "../../comm/mytable";
import { formatDate, getTimeDiff, updateTimeByUtc } from "common/js/util";
import { URL_IBMONTHLYINDEX } from "api/commissionApi";
import { Api } from "api/commissionEnv";
let api = new Api();

export default {
  name: "monthlyIBResult",
  mixins: [
    require("common/mixin/base.js").base({
      salesMonthlyLan: "salesMonthlyResult"
    })
  ],
  props: ["curArea"],
  data() {
    return {
      trData: [],
      url: "",
      timeDiff: 0,
      beginTime: "",
      endTime: "",
      loading: true,
      changeTime: false,
      link: {
        key: ["saleCommResult"],
        path: "saleMonCommResult"
      },
      page: {
        active: 1,
        pageLeng: 0
      },
      selPage: {
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      }
    };
  },
  mounted() {
    this.timeDiff = getTimeDiff();
    if (sessionStorage.getItem("back")) {
      let backObj = JSON.parse(sessionStorage.getItem("back"));
      if (backObj.path === "saleMonthlyResult") {
        this.beginTime = backObj.beginTime;
        this.endTime = backObj.endTime;
        this.page.active = backObj.pageNum + 1;
        this.selPage.limit = backObj.pageSize;
      }
      this.tableAjax();
      sessionStorage.removeItem("back");
    } else {
      this.tableAjax();
    }
  },
  methods: {
    searchData() {
      this.page.active = 1;
      this.tableAjax();
    },
    tableAjax() {
      this.loading = true;
      this.changeTime = true;
      this.url = api.getUrl20(this.curArea,URL_IBMONTHLYINDEX)
      let obj = {
        params: {
          type: "SALES",
          beginTime: formatDate(this.beginTime),
          endTime: formatDate(this.endTime),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      };
      this.$http.get(this.url, obj).then(res => {
        this.trData = res.data.data.rows;
        this.page.pageLeng = res.data.data.count;
        this.setOfficeState();
        this.loading = false;
      });
    },
    setOfficeState() {
      let list = this.salesMonthlyLan.indexStatusList;
      if (Object.prototype.toString.call(this.trData) == "[object Array]") {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index];
          temp.saleCommResult = this.salesMonthlyLan.indexTh[1].name;
          temp.status =
            temp.STATUS || temp.STATUS == 0 ? list[temp.STATUS] : "";
          if (this.changeTime)
            temp.LAST_UPDATE = updateTimeByUtc(this.timeDiff, temp.LAST_UPDATE);
        });
      }
    }
  },
  computed: {
    back() {
      return JSON.stringify({
        path: "saleMonthlyResult",
        pageSize: this.selPage.limit,
        pageNum: this.page.active - 1,
        beginTime: this.beginTime,
        endTime: this.endTime
      });
    },
    name() {
      return this.salesMonthlyLan.indexText;
    },
    downLoadTran() {
      return { STATUS: this.salesMonthlyLan.indexStatusList };
    },
    thData() {
      return this.salesMonthlyLan.indexTh;
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: "get",
        getKey: ["data", "data", "rows"],
        ajaxPar: {
          type: "SALES",
          pageSize: this.page.pageLeng,
          pageNum: 0,
          lang: this.LANGUAGE,
          beginTime: formatDate(this.beginTime),
          endTime: formatDate(this.endTime)
        }
      };
    }
  },
  watch: {
    salesMonthlyLan() {
      this.changeTime = false;
      this.setOfficeState();
    },
    curArea() {
      (this.beginTime = ""), (this.endTime = ""), (this.page.active = 1);
      this.tableAjax();
    }
  },
  components: {
    mtable
  }
};
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.monthlyHandle {
  float: left;
  .searchDiv {
    float: left;
    margin-right: 20px;
  }
  .btnDiv {
    float: left;
    margin-right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// saleMonthlyResult.vue?379b1d1d